import { useMemo } from 'react';
import { BoxProps } from '@chakra-ui/react';
import { Button, Colors, Icon } from '@mercator-gcp/grout';

const buttonStyle = {
  borderRadius: 4,
  fontSize: '13px',
  letterSpacing: '-0.13px',
  py: '8px',
  paddingRight: '12px',
  paddingLeft: '12px',
  height: '32px',
  border: '1px solid',
  borderColor: Colors.ArmyGreen300,
  width: '100%',

  '&:focus': {
    background: Colors.ArmyGreen100,
    border: '1px solid',
    borderColor: Colors.ArmyGreen300,
    paddingRight: '12px',
    paddingLeft: '12px',
  },
  '&:hover': {
    background: Colors.ArmyGreen100,
    border: '1px solid',
    borderColor: Colors.ArmyGreen300,
    paddingRight: '12px',
    paddingLeft: '12px',
  },
};

type Props = {
  provider: 'google' | 'microsoft';
  label: string;
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  sx?: BoxProps['sx'];
};

const SSOButton = ({
  provider,
  label,
  onClick,
  isLoading,
  isDisabled,
  sx = {},
}: Props) => {
  const style = useMemo(() => {
    return { ...buttonStyle, ...sx };
  }, [buttonStyle, sx]);

  const iconName = useMemo(() => {
    if (provider === 'google') {
      return Icon.Name.Google;
    }
    if (provider === 'microsoft') {
      return Icon.Name.Microsoft;
    }

    return null;
  }, [provider]);

  if (!iconName) {
    return null;
  }

  return (
    <Button
      variant="unstyled"
      sx={style}
      onClick={onClick}
      startAdornment={<Icon name={iconName} />}
      isLoading={isLoading}
      isDisabled={isDisabled}
    >
      {label}
    </Button>
  );
};

export default SSOButton;
